module.exports = __webpack_public_path__ + "img/ic-next.da307817.svg";